import BaseTable from '@Components/table/BaseTable/BaseTable'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Grid } from '@mui/material'
import UserReportActions from '@Stores/report/actions/user-report.action'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { CommonService } from '@Services/common.service'
import * as Redux from 'redux'
import moment from 'moment'
import { useHistory, useParams } from 'react-router'
import {
    accessoryHeaders,
    ammunitionHeaders,
    firearmHeaders,
    inspectionHeaders,
    insuranceHeaders,
    invoiceHeaders,
    partHeaders,
    safeStorageHeaders,
} from './tableHeaders'

const dummyData = [
    {
        date: '05/05/2020',
        reference: '1568-6966',
        daysOpen: ' 5',
        deptCode: 'SS-Stockton',
        action: 'REMOVAL-BLOCK',
        status: 'CLOSED',
        dataClosed: '06/06/2020',
    },
]

interface IReportDetailProps {
    getUserDetail: (id: string) => void
    getFirearms: (id: string) => void
    getInsurances: (id: string) => void
    getInspections: (id: string) => void
    getSafeStorages: (id: string) => void
    getAccessories: (id: string) => void
    getParts: (id: string) => void
    getAmmunitions: (id: string) => void
    getInvoices: (id: string) => void
    userDetail: any
    firearms: []
    insurances: []
    inspections: []
    safeStorages: []
    accessories: []
    parts: []
    ammunitions: []
    invoices: []
}

const ReportDetail = (props: IReportDetailProps) => {
    const {
        getUserDetail,
        getFirearms,
        getInsurances,
        getInspections,
        getSafeStorages,
        getAccessories,
        getParts,
        getAmmunitions,
        getInvoices,
        userDetail,
        firearms,
        insurances,
        inspections,
        safeStorages,
        accessories,
        parts,
        ammunitions,
        invoices,
    } = props

    const params = useParams()
    const history = useHistory()
    const { id }: any = params
    // const [id, setId] = useState('7e5c3443-ad8b-4f01-9d03-3a59996d7f1b')

    useEffect(() => {
        getUserDetail(id)
        getFirearms(id)
        getInsurances(id)
        getInspections(id)
        getSafeStorages(id)
        getAccessories(id)
        getParts(id)
        getAmmunitions(id)
        getInvoices(id)
    }, [])

    return (
        <div className="px-4">
            <p
                className="fs-12 blue-text cursor-pointer"
                onClick={() => {
                    history.push('/admin/report')
                }}
            >
                <ArrowBackIosIcon className="fs-14" />
                Back
            </p>
            <div className="page-hr mb-3" />
            <p className="fs-20 font-weight-bold">USER DETAIL</p>

            <Grid container>
                <Grid sm={12} md={10} item>
                    <div className="mb-3">
                        {userDetail?.profile?.firstName ? (
                            <p className="fs-14 mb-0">
                                Mr. {userDetail?.profile?.firstName}&nbsp;
                                {userDetail?.profile?.middleName}&nbsp;
                                {userDetail?.profile?.lastName}
                            </p>
                        ) : (
                            ''
                        )}
                        {userDetail?.phone ? (
                            <p className="fs-14 mb-0">
                                Tel {userDetail?.phone}{' '}
                            </p>
                        ) : (
                            ''
                        )}
                        {userDetail?.email ? (
                            <p className="fs-14 mb-0">
                                Email {userDetail?.email}{' '}
                            </p>
                        ) : (
                            ''
                        )}
                        {userDetail?.profile?.address ||
                        userDetail?.profile?.city?.name ||
                        userDetail?.profile?.state?.name ||
                        userDetail?.profile?.country?.name ? (
                            <p className="fs-14 mb-0">
                                Address {`${userDetail?.profile?.address},`}
                                &nbsp;
                                {`${userDetail?.profile?.city?.name},`}&nbsp;
                                {`${userDetail?.profile?.state?.name},`}&nbsp;
                                {userDetail?.profile?.country?.name}
                            </p>
                        ) : (
                            ''
                        )}
                        {userDetail?.profile?.zipCode ? (
                            <p className="fs-14 mb-0">
                                Zip {userDetail?.profile?.zipCode}
                            </p>
                        ) : (
                            ''
                        )}
                    </div>
                </Grid>

                <Grid sm={12} md={2} item>
                    {userDetail?.profile?.gender ? (
                        <p className="fs-14 mb-0">
                            <span className="text-gray-78">Gender:</span>
                            <span>
                                {CommonService.textCapitalize(
                                    userDetail?.profile?.gender
                                )}
                            </span>
                        </p>
                    ) : (
                        ''
                    )}
                    {userDetail?.profile?.dob ? (
                        <p className="fs-14 mb-0">
                            <span className="text-gray-78">DOB:</span>
                            <span>
                                {moment(userDetail?.profile?.dob).format(
                                    'DD/MM/YYYY'
                                )}
                            </span>
                        </p>
                    ) : (
                        ''
                    )}
                </Grid>
            </Grid>
            <div className="page-hr mb-4" />

            <Grid container>
                <Grid sm={12} md={10} item />

                <Grid sm={12} md={2} item>
                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Firearm:
                        </span>
                        <span>{userDetail?.totalFirearms}</span>
                    </p>
                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Accessory:
                        </span>
                        <span>{userDetail?.totalAccessories}</span>
                    </p>
                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Part:
                        </span>
                        <span>{userDetail?.totalParts}</span>
                    </p>
                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Ammunition:
                        </span>
                        <span>{userDetail?.totalAmmunitions}</span>
                    </p>

                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Invoice:
                        </span>
                        <span>{userDetail?.totalPayments}</span>
                    </p>
                    <p className="fs-14 mb-0">
                        <span className="d-inline-block w-120 text-gray-78">
                            Insurance:
                        </span>
                        <span>{userDetail?.totalInsurances}</span>
                    </p>
                    <p className="fs-14">
                        <span className="d-inline-block w-120 text-gray-78">
                            User&apos;s Safe:
                        </span>
                        <span>{userDetail?.totalSafeStorages}</span>
                    </p>
                </Grid>
            </Grid>
            <p className="fs-20 font-weight-bold">Firearm</p>
            <BaseTable
                headers={firearmHeaders}
                data={firearms}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">Accessories</p>
            <BaseTable
                headers={accessoryHeaders}
                data={accessories}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">Part</p>
            <BaseTable
                headers={partHeaders}
                data={parts}
                className="table-min-height mb-4"
            />

            <p className="fs-20 font-weight-bold">Ammunition</p>
            <BaseTable
                headers={ammunitionHeaders}
                data={ammunitions}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">Invoice</p>
            <BaseTable
                headers={invoiceHeaders}
                data={invoices}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">Insurance</p>
            <BaseTable
                headers={insuranceHeaders}
                data={insurances}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">Inspection</p>
            <BaseTable
                headers={inspectionHeaders}
                data={inspections}
                className="table-min-height mb-4"
            />
            <p className="fs-20 font-weight-bold">User’s Safe</p>
            <BaseTable
                headers={safeStorageHeaders}
                data={safeStorages}
                className="table-min-height mb-4"
            />
        </div>
    )
}

const mapStateToProps = (store: any) => {
    const {
        userDetail,
        firearms,
        insurances,
        inspections,
        safeStorages,
        accessories,
        parts,
        ammunitions,
        invoices,
    } = store?.report?.users
    return {
        userDetail,
        firearms,
        insurances,
        inspections,
        safeStorages,
        accessories,
        parts,
        ammunitions,
        invoices,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const {
        getUserDetail,
        getFirearms,
        getInsurances,
        getInspections,
        getSafeStorages,
        getAccessories,
        getParts,
        getAmmunitions,
        getInvoices,
    } = UserReportActions
    return {
        getUserDetail: (id: string) => dispatch(getUserDetail(id) as any),
        getFirearms: (id: string) => dispatch(getFirearms(id) as any),
        getInsurances: (id: string) => dispatch(getInsurances(id) as any),
        getInspections: (id: string) => dispatch(getInspections(id) as any),
        getSafeStorages: (id: string) => dispatch(getSafeStorages(id) as any),
        getAccessories: (id: string) => dispatch(getAccessories(id) as any),
        getParts: (id: string) => dispatch(getParts(id) as any),
        getAmmunitions: (id: string) => dispatch(getAmmunitions(id) as any),
        getInvoices: (id: string) => dispatch(getInvoices(id) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail)
